import { render } from "./StudentEditHeaderLower.vue?vue&type=template&id=059adb52&scoped=true&ts=true"
import script from "./StudentEditHeaderLower.vue?vue&type=script&lang=ts"
export * from "./StudentEditHeaderLower.vue?vue&type=script&lang=ts"

import "./StudentEditHeaderLower.vue?vue&type=style&index=0&id=059adb52&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059adb52"]])

export default __exports__